const colors = {
  white: '#F3F6F9',
  transparent: '#00000000',
  blueGrey: '#5D748E',
  black: '#1C1C1E',
  blackText: '#575757',
  orange: '#FF9000',
  navBackgroundGrey: '#29292D',
  hoverGrey: '#343438',
  lightGreyOnBlack: '#959BA3',
  lightGrey: '#ACACAC',
  lightHoverGrey: '#E9ECEF',
  logoutHoverGrey: '#1F1F23',
  blue: '#0073B3',
  lightBlue: '#00A4FF',
  disabledGrey: '#54545A',
  lightDisabledGrey: 'rgba(0, 0, 0, 0.26)',
  underlineGrey: '#666666',
  red: '#C6192D',
  errorRed: '#f44336',
  warningYellow: '#ff9000',
  dropzoneGrey: '#ddd',
  successGreen: '#2e7d32',
};

export default colors;
